<template>
  <v-page no-padding>
    <div class="h-100">
      <participants :message-thread-id="$route.params.id" />
    </div>
  </v-page>
</template>

<script>
import Participants from "@/components/message-thread/Participants"

export default {
  components: {
    Participants
  }
}
</script>
